@if (!oculto && !router.url.startsWith('/faq')) {
    <div class="help-floating">
        <button type="button" (click)="abrir()" class="help-shortcut" aria-label="¿Necesitás ayuda?"
            title="¿Necesitás ayuda?" aria-haspopup="dialog" [attr.aria-expanded]="visible">
            <i class="pi pi-question" aria-hidden="true"></i>
        </button>
        <button type="button" class="help-dismiss" (click)="ocultar()" aria-label="Ocultar botón de ayuda" title="Ocultar ayuda">
            <i class="pi pi-times" aria-hidden="true"></i>
        </button>
    </div>
}
<p-dialog header="¿Necesitás ayuda?" [(visible)]="visible" [modal]="true" [draggable]="false" [resizable]="false"
    [blockScroll]="true" [dismissableMask]="true" [closeOnEscape]="true" closeAriaLabel="Cerrar ayuda" position="bottomright" appendTo="body"
    [maskStyle]="{ zoom: 'calc(1 / var(--app-notebook-zoom, 1))' }"
    [style]="{ width: 'min(28rem, calc(100vw - 1rem))', maxHeight: '90dvh', margin: '0.5rem', borderColor: '#D4A520' }"
    [breakpoints]="{ '640px': 'calc(100vw - 1rem)' }" [contentStyle]="{ padding: '0 1rem 1rem' }">
    @if (visible) {
        <div class="quick-help">
            <p class="quick-intro">En la sección de Ayuda (FAQ) encontrás preguntas frecuentes, guías y referentes.</p>
            <p id="aviso-salida-ayuda" class="quick-warning">Al ir a Ayuda vas a salir de esta página. Si tenés cambios sin guardar, guardalos antes de continuar.</p>
            <div class="quick-actions">
                <button type="button" (click)="visible = false" class="continue-button">No, gracias</button>
                <a routerLink="/faq" [queryParams]="{ area: area }" (click)="visible = false" aria-describedby="aviso-salida-ayuda"><i class="pi pi-book" aria-hidden="true"></i> Ir a Ayuda (FAQ)</a>
            </div>
        </div>
    }
</p-dialog>
